import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { id: "moneyRain" }

import { ref, onMounted, onBeforeUnmount } from 'vue';

interface MoneyItem {
  id: number;
  type: string;
  style: Record<string, string>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'rainOverlay',
  setup(__props) {

const moneyList = ref<MoneyItem[]>([]);
const moneyTypes = ['money1', 'money2', 'money3', 'money4'];
let idCounter = 0;
let spawnInterval: number;

function spawnMoney() {
  const type = moneyTypes[Math.floor(Math.random() * moneyTypes.length)];
  const left = Math.random() * 100;
  const delay = 0;
  const duration = 6 + Math.random() * 4; // 6s to 10s
  const rotation = Math.random() > 0.5 ? 720 : -720;

  const item: MoneyItem = {
    id: idCounter++,
    type,
    style: {
      left: `${left}vw`,
      animationDelay: `${delay}s`,
      animationDuration: `${duration}s`,
      '--rotation': `${rotation}deg`,
    },
  };

  moneyList.value.push(item);

  // Remove item after animation finishes
  setTimeout(() => {
    moneyList.value = moneyList.value.filter(i => i.id !== item.id);
  }, duration * 1000);
}

onMounted(() => {
  spawnInterval = window.setInterval(() => {
    for (let i = 0; i < 15; i++) {
      spawnMoney();
    }
  }, 300); // Add 3 every 300ms
});

onBeforeUnmount(() => {
  clearInterval(spawnInterval);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moneyList.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: _normalizeClass(['money', item.type]),
        style: _normalizeStyle(item.style)
      }, null, 6))
    }), 128))
  ]))
}
}

})